import { NgModule, Type } from '@angular/core';

import { BodyKnowledgeDetailComponent } from './body-knowledge-detail.component';
import { CommonModule } from '@angular/common';

const components: Type<any>[] = [BodyKnowledgeDetailComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [components],
  exports: [components],
})
export class BodyKnowledgeDetailModule { }
